








import AbpBase from "../../../../../../lib/abpbase"
import {Component, Prop} from "vue-property-decorator"

@Component
export default class MedDoc extends AbpBase {
	@Prop({type:Array,default: []}) doctors:Array<any>
	@Prop({type:Number,default: 0}) width:Number
	@Prop({type:String,default: ''}) value:String
	select(val:any){
		this.$emit('select', val)
	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/electronicMedicalRecord/patient/parts/medDoc/parts/selectDoctor.vue